export default {
  global: {
    home: 'Accueil',
    login: 'Login',
    submit: 'Enregistrer',
    reset: 'Réinitialiser',
    delete: 'Supprimer',
    clear: 'Vider',
    init: 'Réinitialiser',
    send: 'Envoyer',
    confirm: 'Confirmer',
    min: 'Min',
    max: 'Max',
    confirmDelete: 'Voulez vous vraiment supprimer cet element ?',
    no_result: 'Pas de résultat',
    no_select: 'Aucune sélection',
    close: 'Fermer',
    back: 'Retour',
    cancel: 'Annuler',
    update: 'Modifier',
    updated: 'Modifiée',
    updatedat: 'Modifiée le',
    updatedby: 'Modifiée par',
    view: 'Voir',
    viewall: 'Tout voir',
    field: 'Champ',
    value: 'Valeur',
    filters: 'Filtrer',
    data_unavailable: 'Aucune donnée',
    loading: 'Chargement...',
    deleted: 'Supprimée',
    created: 'Crée',
    createdat: 'Crée le',
    createdby: 'Crée par',
    uploaded: 'Chargé',
    bigger_zero: 'Veuillez insérer une valeur supérieur à zero!',
    type_something: 'Veuillez saisir quelque chose',
    field_required: 'Champ obligatoire',
    records_per_page: 'Elements par page:',
    actions: 'Actions',
    list: 'Liste',
    add: 'Ajouter',
    datestart: 'Date de début',
    dateend: 'Date de fin',
    name: 'Nom',
    namefr: 'Nom fr',
    fileinput: 'Fichier',
    credentialerror: 'Problème de droits',
    type: 'Type',
    date: 'Date',
    dateCreation: 'Date de création',
    dateUpdate: 'Date de modification',
    true: 'Oui',
    false: 'Non',
    content: 'Contenu',
    access: 'Droits',
    editimage: 'Modifier l\'image',
    timeline: 'Chronologie',
    validate: 'Valider',
    invalidate: 'Invalider',
    explore: 'Voir détail',
    addcombo1: 'Appuyez sur',
    addcombo2: 'pour créer un nouveau élément',
    download: 'Télécharger',
    file: 'Fichier',
    title: 'Titre',
    logo: 'Logo',
    export: 'Exporter',
    id: 'Id',
    maxsize: 'Fichier trop volumineux',
    language: 'Langue',
    parent: 'Parent',
    hub: 'Hub',
    default: 'Défaut',
    enabled: 'Activé',
    nopicture: 'Aucune photo',
    available: 'Disponible',
    number: 'N°',
    description: 'Description',
    descriptionfr: 'Description fr',
    dashboard: 'Dashboard',
    reference: 'Reference',
    uuid: 'Uuid',
    comment: 'Commentaire',
    version: 'Version',
    news: 'Nouveautés',
    easy: 'Facile',
    normal: 'Normal',
    hard: 'Difficile',
    linkshare: 'Lien à partager',
    pair: 'Appairer',
    check: 'Verifier',
    savecalibration: 'Sauvegarde calibration',
    controlsettings: 'Paramètres pour Control',
    archive: 'Archivé',
  },
  menu: {
    production:   'Production',
    qualitycheck:   'Quality check',
    versionning:   'Versionning',
    profile:   'Profils',
    product:   'Produit',
    administration:   'Administration',
    sav:   'Support client',
    quality:   'Qualité',
    documentation:   'Documentation',
    language: {
      english:   'English',
      french:   'French',
    },
    user: {
      profile: 'Profil',
      badge: 'Badge',
      mybadge: 'Mes badges',
      badgelist: 'Liste des badges',
      logout: 'Déconnexion',
      notificationsubscriber: 'Notifications',
    },
  },
  app: {
    apps: 'Applications',
    app: 'Application',
    url: 'Url',
    connectors: 'Connector logs',
    startconnector: 'Lancer connector',
  },
  service: {
    services: 'Services',
    service: 'Service',
  },
  macro: {
    macrotype: 'Type macro',
    macrotypes: 'Types macro',
    loadprocess: 'Chargement processus',
  },
  article: {
    articles: 'Articles',
    article: 'Article',
    title: 'Titre',
    titlefr: 'Titre fr',
    link: 'Lien',
    linkfr: 'Lien fr',
    enabled: 'Actif',
  },
  designfile: {
    designfiles: 'Bibliothèque 3D',
    designfile: 'Fichier 3D',
    changeviewer: 'Changer l\'aperçu',
    designfiletypes: 'Types fichiers 3D',
    designfiletype: 'Type fichier 3D',
    type: 'Type',
    author: 'Auteur',
    license: 'Licence',
    licensehelpchoice: 'Pour les fichiers 3D Lynxter, merci de choisir les licences suivantes selons les types: CC BY-NC-ND 4.0 (Démonstration), CC BY-NC-SA 4.0 (Calibration), CC BY-NC-SA 4.0 (Réparation)',
    description: 'Description',
    descriptionfr: 'Description fr',
  },
  process: {
    processes: 'Processus',
    process: 'Process',
    documentation: 'Tutoriel',
    documentations: 'Tutoriels',
    documentationsadmin: 'Tutoriel Rech.',
    documentationtype: 'Type Tutoriel',
    documentationtypes: 'Types Tutoriel',
    steps: 'Etapes',
    step: 'Etape',
    fields: 'Champs',
    field: 'Champ',
    processesschema: 'Processus schéma',
    processschema: 'Processus schéma',
    loadmaterial: 'Chargement matériaux',
    unloadmaterial: 'Déchargement matériaux',
    loadtool: 'Chargement outil',
    unloadtool: 'Déchargement outil',
    loadoption: 'Chargement option',
    unloadoption: 'Déchargement option',
    calibtool: 'Calibration outil',
    calibmachine: 'Calibration machine',
    blanking: 'Mise à blanc',
    verification: 'Vérification',
    maintenance: 'Maintenance',
    preprinting: 'Pre-impression',
    postprinting: 'Post-impression',
    time: 'Temps (min)',
    intensity: 'Difficulté',
    defaultprocess: 'Défaut',
    tempprogress: 'Afficher température',
    movementpanel: 'Afficher panel mouvement',
    logpanel: 'Afficher panel de log',
    validator: 'Ref. de validation',
    actionref: 'Ref. d\'action',
    moduleref: 'Ref. module',
    subtitle: 'Sous-titre vidéo',
    subtitlefr: 'Sous-titre fr vidéo',
    linkproductcustomer: 'Liens Produit / client',
    defaultprocessmachine: 'Tutoriel machine',
    doorOpen: 'Porte ouverte',
    withoutModuleOnly: 'Exclusivement sans module',
    category: 'Catégorie',
    fixtureRef: 'Référence de la fixture'
  },
  ticket: {
    ticket: 'Ticket',
    tickets: 'Tickets',
    bugtypes: 'Types de bug',
    bugtype: 'Type de bug',
    actiontypes: 'Types d\'action',
    actiontype: 'Type d\'action',
    ticketstatuses: 'Statuts ticket',
    ticketstatus: 'Statut ticket',
    init: 'Initial',
    hub: 'Hub',
    finish: 'Fermée',
    waiting: 'En attente',
    response: 'Réponse',
    process: 'A traiter',
    important: 'Important',
    ticketorigins: 'Origines ticket',
    ticketorigin: 'Origine ticket',
    ticketactions: 'Actions ticket',
    ticketaction: 'Action ticket',
    content: 'Description',
    timeWork: 'Temps de travail (min)',
    resolution: 'Résolution',
    assigned: 'Assignée',
    tags: 'Tags',
    tag: 'Tag',
    statuschange: 'Changement statut',
    public: 'Publique',
    number: 'N°',
    newrelease: 'Nouvelle release',
    datebug: 'Date incident',
    dateend: 'Date de clôture',
    archive: 'archivé'
  },
  contact: {
    contacts: 'Contacts',
    contact: 'Contact',
    firstname: 'Prénom',
    lastname: 'Nom',
    customer: 'Client',
    email: 'Email',
    phone: 'Téléphone',
    locale: 'Langue',
    comptehub: 'Compte HubClient',
  },
  contract: {
    contracts: 'Contrats',
    contract: 'Contrat',
    contracttypes: 'Types de contrat',
    contracttype: 'Type de contrat',
    description: 'Description',
    duration: 'Temps (jour)',
    timeinit: 'Temps initial (min)',
    timeused: 'Temps utilisé (min)',
    ref: 'Référence',
    start: 'Date de début',
    end: 'Date de fin',
    type: 'Type',
    customer: 'Client',
    products: 'Produits',
    comment: 'Commentaire',
    enable: 'Actif',
    guarantee: 'Garantie',
    maintenance: 'Maintenance',
    expired: 'expiré'
  },
  profile: {
    parameter:   'Systemes',
    profilefiles:   'Fichiers profil',
    profilefile:   'Fichier profil',
    profilefilesutils: 'Fichier profil utilitaire',
    public:   'Hub',
    experimental:   'Experimental',
    version:   'Version',
    newrelease:   'Nouveauté',
    updaterelease:   'Nouvelle mise à jour',
    reference: 'Référence',
    description: 'Description',
    descriptionfr: 'Description fr',
    customersreserved: 'Reservé pour les clients',
    accessory: {
      accessories:   'Accessoires',
      accessory:   'Accessoire',
      name:   'Nom',
      model:   'Modèle',
      version:   'Version',
    },
    option: {
      options:   'Options',
      option:   'Option',
      name:   'Name',
      model:   'Modèle',
      version:   'Version',
      parent:   'Version parent',
    },
    controlunit: {
      controlunits:   'Unités de contrôle',
      controlunit:   'Unité de contrôle',
      name:   'Nom',
      model:   'Modèle',
      version:   'Version',
      parent:   'Unité de contrôle parent',
    },
    industrialcomputer: {
      industrialcomputers:   'Ordinateurs industriels',
      industrialcomputer:   'Ordinateur industriel',
      name:   'Nom',
      model:   'Modèle',
      version:   'Version',
      parent:   'Ordinateur industriel parent',
    },
    operatingsystem: {
      operatingsystems:   'OS',
      operatingsystem:   'OS',
      name:   'Nom',
    },
    machine: {
      machines:   'Machines',
      machine:   'Machine',
      models:   'Modèles machines',
      versions:   'Versions machines',
      name:   'Nom',
      model:   'Modèle',
      parent:   'Machine parent',
      version:   'Version',
      compatiblesMachines: 'Machines compatibles',
      compatiblesToolheads: "Têtes d'impression compatibles"
    },
    material: {
      materials:   'Matériaux',
      material:   'Matière',
      products: 'Produits matière',
      product: 'Produit matière',
      productversions: 'Versions produit matière',
      productversion: 'Version produit matière',
      productlots: 'Lots produit matière',
      productlot: 'Lot produit matière',
      externallot: 'N° lot Externe',
      datemanufacture: 'Date de fabrication',
      dlu: 'DLU',
      colors: 'Couleurs matières',
      feedspecs: 'Matière feed specs',
      manufacturers: 'Constructeurs matières',
      mediums: 'Mediums',
      states: 'Etat matière',
      types: 'Type matière',
      supplies: 'Racks matières',
      supply: 'Rack matière',
      subsupplies: 'Rack entrées',
      subsupply: 'Rack entrée',
      parent:   'Rack matière parent',
      name:   'Nom',
      shortname: 'Abreviation',
      namepub: 'Nom pub',
      color: 'Couleur',
      comment: 'Commentaire',
      medium: 'Medium',
      feedspec: 'Feed spec.',
      manufacturer: 'Constructeur',
      type: 'Type',
      machine: 'Machine',
      state: 'Etat',
      version: 'Version',
      input: 'Entrée',
      public: 'Publique',
      description: 'Description',
      measures: 'Spécifications',
      tempresistance: 'Résitance à la température',
      chemicalresistance: 'Résistance chimique',
      uvresistance: 'Résistance aux UV',
      mecaresistance: 'Résistance mécanique',
      abrasionresistance: 'Résistance à l\'abrasion',
      tractionresistance: 'Résistance à la traction (MPa)',
      complexity: 'Complexicité de mise en oeuvre',
      hardness: 'Dureté (score)',
      hardnessshore: 'Dureté',
      hardnessshoretype: 'Dureté type shore',
      elongation: 'Allongement max (%)',
      tenacity: 'Ténacité (MPa.m^1/2)',
      cost: 'Coût (€)',
      density: 'Densité',
      electrical: 'Propriétés électriques',
      thermal: 'Propriétés thermiques',
      dielectric: 'Propriétés diélectriques',
      tempfusion: 'Température fusion (°C)',
      graphradar: 'Graphique Radar',
    },
    nozzle: {
      nozzles:   'Buses',
      nozzle:   'Buse',
      nozzlesin:  'Entrées buse',
      nozzlesout:  'Diamètres buse',
      nozzlein:  'Diamètre buse',
      nozzleout:  'Sortie buse',
      manufacturers:  'Constructeur buse',
      types:  'Types buse',
      materials:  'Matériaux buse',
      visuals:  'Visuels buse',
      name:   'Nom',
      manufacturer: 'Constructeur',
      type: 'Type',
      material: 'Matière',
      visual: 'Visuel',
      size: 'Taille',


    },
    printingsurface: {
      printingsurfaces:   'Surfaces impression',
      printingsurface:   'Surface impression',
      materials:   'Matériaux surface impression',
      sizes:   'Tailles surface impression',
      thickness:   'Epaisseurs surface impression',
      name:   'Nom',
      thicknessname: 'Epaisseur',
      size: 'Taille',
      material: 'Matière',
      version: 'Version',
    },
    score: {
      scores:   'Scores',
      score:   'Score',
      benchmarks:   'Score benchmarks',
      tools:   'Score outils',
      name:   'Nom',
      medium:   'Medium',
      tool:   'Outil',
      quality:   'Qualité',
      benchmark:   'Benchmark',
    },
    profileparameter: {
      parameters:   'Paramètres profil',
      parameter:   'Paramètre profil',
      sets:   'Paramètres profil set',
      set:   'Paramètre profil set',
      values:   'Paramètres profil valeur',
      name:   'Nom',
      bracket: 'Support',
      unit: 'Unité',
      tab: 'Colonne',
      section0: 'Section lvl 0',
      section1: 'Section lvl 1',
      softwareversion: 'Logiciel',
      uuid: 'Uuid',
      setup: 'Configuration',
      strategy: 'Strategie',
      date: 'Date',
      version: 'Version',
      profileparameter: 'Nom paramètre name',
      value: 'Valeur'
    },
    sectionparameter: {
      sectionparameters:   'Paramètres de section',
      sectionparameter:   'Paramètre de section',
      name:   'Nom',
      bracket: 'Champ',
      software: 'Logiciel',
    },
    strategy: {
      strategies:   'Stratégies profil',
      strategy:   'Stratégie profil',
      qualities:   'Qualité stratégie profil',
      uuid:   'Uuid',
      software: 'Logiciel',
      quality: 'Qualité',
      part: 'Outil pièce',
      infill: 'Outil remplissage',
      densesupport: 'Outil support D.',
      support: 'Outil support',
      skirt: 'Outil jupe',
      raft: 'Outil radeau',
      primepillar: 'Outil principal',
      oozeshield: 'Outil bouclier anti bavure',
    },
    quality: {
      qualities:   'Qualités',
      quality:   'Qualité',
      focus:   'Qualité central',
      layers:   'Hauteurs couche (mm)',
      name:   'Nom',
      focusname:   'Focus',
      layer: 'Couche',
      nozzleout : 'Diamètre buse (mm)',
      nozzlesout : 'Diamètres buse',
      height: 'Hauteur'
    },
    setupdefinition: {
      definitions:   'Définitions configuration',
      definition:   'Définition configuration',
      definitionssub:   'Sous-définitions configuration',
      definitionsub:   'Sous-définition configuration',
      uuid:   'Uuid',
      extruderquantity:   'Extruders',
      tempcontroler:   'Temp. contrôle',
      machine:   'Machine',
      toolhead:   'Tête outil',
      materialsupply:   'Rack matière',
      printingsurface:   'Surface impression',
      tool:   'Outil',
      material:   'Matière',
      nozzle:   'Buse',
    },
    software: {
      softwares:   'Logiciels',
      versions: 'Versions logiciel',
      name:   'Nom',
      fao:   'FAO',
      licence:   'Licence',
      software:   'Logiciel',
      version:   'Version',
    },
    tool: {
      toolheads:   'Têtes outil',
      toolhead:   'Tête outil',
      toolheadssub:   'Compositions Tête outil',
      toolheadsub:   'Composition Tête outil',
      tools:   'Outils',
      tool:   'outil',
      extruders:   'Extruders',
      extruder:   'Extruder',
      heaters:   'Heaters',
      heater:   'Heater',
      name:   'Nom',
      comment: 'Commentaire',
      number: 'N°',
      toolheaddef: 'Définition tête outil',
      version:   'Version',
      machine: 'Machine',
      inputquantity: 'Entrée',
      outputquantity: 'Sortie',
      model: 'Modèle',
      optionsubtool: 'Option',
      materialmedium: 'Medium',
      materialfeedspec: 'Matière feed spec.',
      nozzletype: 'Type buse',
      parent:   'Tête outil parent',
    },
  },
  version: {
    link: {
      links: 'Liens',
      link: 'Lien',
      name:   'Nom',
      url:   'Url',
    },
    changelog: {
      changelogs: 'Historique de changement',
      changelog: 'Historique de changement',
      name: 'Nom',
      type: 'Type',
      typevalue: 'Valeur',
      start: 'Départ',
      end: 'Fin',
      machine: 'Machine',
      toolhead: 'Tête outil',
      materialsupply: 'Rack matière',
      controlunit: 'Unité de contrôle',
      industrialcomputer: 'Ordinateur industriel',
      printingsurface: 'Surface impression',
      operatingsystem: 'OS',
      accessory: 'Accessoire',
      option: 'Option',
      softwareversion: 'Logiciel',
      newfeatures: 'Nouvelles versions',
      bugfixes: 'Bugs résolus',
      knownbugs: 'Connaissances bugs',
      notes: 'Notes',
      developexternal: 'Développement externe',
      developer: 'Développeur',
    },
  },
  qualitycheck: {
    customer: {
      customers: 'Clients',
      customer: 'Client',
      name:   'Nom',
      comment:   'Commentaires',
      description:   'Description',
      tags:   'Tags',
      tag:   'Tag',
    },
    distributor: {
      distributors: 'Distributeurs',
      distributor: 'Distributeur',
      name:   'Nom',
      emailsupport: 'Email support',
      comment:   'Commentaires',
    },
    product: {
      products: 'Produits client',
      product: 'Produit client',
      production: 'Production',
      status: 'Statuts',
      statu: 'Statut',
      name:   'Nom',
      customer:   'Client',
      customerloan:   'Prêt client',
      location:   'Lieu',
      machine: 'Machine',
      machines: 'Machines',
      toolhead: 'Tête outil',
      toolheads: 'Têtes outil',
      option: 'Option',
      options: 'Options',
      materialsupply: 'Rack matière',
      industrialcomputer: 'Ordinateur industriel',
      operatingsystem: 'OS',
      printingsurface: 'Surface impression',
      softwareversion:   'Logiciel',
      controlunit: 'Unité de contôle',
      accessory: 'Accessoire',
      userassembly: 'Assembleur',
      startassembly: 'Début assemblage',
      endassembly: 'Fin assemblage',
      delivery: 'Livraison',
      reforderfab: 'Ref. ordre fab.',
      type : 'Type',
      typevalue: 'Dispositif',
      nbproduct: 'Quantité de produit',
      datas: 'Caractéristiques spécifiques',
      data: 'Caractéristique spécifique',
      productparent: 'Produit parent',
      productchildren: 'Composition produit',
      notice: 'Notice',
      material: 'Matériaux',
      updatesoft: 'Mise à jour logiciel',
      factoryreset: 'Réinitialisation d\'usine',
      producttypefiles: 'Fichiers produit',
      producttypefile: 'Fichier produit',
      producttypefiletypes: 'Types de fichier produit',
      producttypefiletype: 'Type de fichier produit',
      ipmachine: 'Ip machine',
      productcomposition: 'Composition du produit',
      assembly: 'Assemblage',
      link: 'Lien vers le tuto'
    },
    qualitycheck: {
      checks: 'Quality checks',
      check: 'Quality check',
      history: 'Liste quality checks',
      name: 'Nom',
      comment: 'Commentaire',
      usertesting: 'Testeur',
      start : 'Début test',
      end : 'Fin test',
      qualitycheckvalues: 'Résultats',
      qualitycheckvalue: 'Résultat',
      product: 'Produit client',
      success: 'Succès',
    },
    test: {
      tests: 'Tests',
      test: 'Test',
      number: 'Numéro',
      name : 'Nom',
      refexternal : 'Référence externe',
      namefr : 'Nom fr',
      issue : 'Problème',
      issuefr : 'Problème fr',
      comment : 'Commentaire',
      commentfr : 'Commentaire fr',
      machine : 'Machine',
      toolhead: 'Tête outil',
      materialsupply: 'Rack matière',
      industrialcomputer: 'Ordinateur industrial',
      operatingsystem: 'OS',
      controlunit: 'Unité de contrôle',
      accessory: 'Accessoire',
      softwareversion: 'Logiciel',
      option: 'Option',
      type : 'Type',
      typevalue: 'Dispositif',
    },
    value: {
      types: 'Types résultat',
      type: 'Type résultat',
      result: 'Résultat',
      name : 'Nom',
      originvalue : 'Valeur original'
    },
  },
  priority: {
    priorities:   'Priorités',
    priority:   'Priorité',
    intensity:   'Intensité',
    init:   'intial',
  },
  administration: {
    administration:   'Administration',
    securityparameter: {
      securityparameters: 'Paramètres de sécurité',
      securityparameter: 'Paramètre de sécurité',
      parameter: 'Paramètre',
      value: 'Valeur',
      comment: 'Description',
      forgot_password_time: 'Temps (minutes) de validation du lien de mot de passe oublié',
      login_failure_max: 'Nombre de connexion échouée max avant le blocage d\'un compte',
      block_password_time: 'Temps (minutes) de blocage d\'un compte et Temps (minutes) où est comptabilisé le nombre de connexion échouée pour le blocage d\'un compte',
      block_failure_allTime: 'Permet de bloquer ou non sans limite de temps (0 pour bloquer avec une limite de temps et 1 pour bloquer sans limite de temps)',
      change_password_time: 'Temps (jours) pour forcer le changement de mot de passe',
      old_password_nb: 'Nombre de mot de passe stocké pour verifier si le nouveau mot de passe est différent des anciens',
      password_size_min: 'Politique du mot de passe, longueur minimum du mot de passe',
      password_number_min: 'Politique du mot de passe, Nombre de chiffres minimum dans le mot de passe',
      password_lowercase_min: 'Politique du mot de passe, Nombre de charactère minuscule minimum dans le mot de passe',
      password_uppercase_min: 'Politique du mot de passe, Nombre de charactère majuscule minimum dans le mot de passe',
      password_special_min: 'Politique du mot de passe, Nombre de charactère spéciale minimum dans le mot de passe',
      logout_auto_time: 'Temps (minutes) avant déconnexion automatique',
      backup_auto_time: 'Sauvegarde, temps (jours) entre les sauvegardes automatiques',
      backup_server: 'Sauvegarde, addresse du serveur ftp',
      backup_port: 'Sauvegarde, port du serveur ftp',
      backup_login: 'Sauvegarde, login du serveur ftp',
      backup_password: 'Sauvegarde, password du serveur ftp',
      backup_folder: 'Sauvegarde, dossier du serveur ftp',
    },
    logs: 'Journaux',
    backup: {
      backups: 'Sauvegardes',
      backup: 'Sauvegarde',
      backupmanual: 'Sauvegarder',
      confirmbackup: 'Voulez vous vraiment lancer une sauvegarde ?',
      success: 'Réussie',
      address: 'Adresse',
      auto: 'Automatique',
      size: 'Taille (ko)',
      finished: 'Fin',
    },
    saves: 'Sauvegardes',
    signature: 'Intégrité des signatures',
    user: {
      users:   'Utilisateurs',
      user:   'Utilisateur',
      connexion: 'Connexion',
      connected: 'Vous êtes connecté',
      forgotyourpassword: 'Mot de passe oublié ?',
      passwordturnover: 'Changement de mot de passe',
      passwordturnovermessage: 'Pour des raisons de sécurité, veuillez changer votre mot de passe.',
      forgotpassword:   'Mot de passe oublié',
      forgotpasswords:   'Demandes de mot de passe oublié',
      forgotpasswordmessage: 'Envoyer une demande de réinitialisation de votre mot de passe par email',
      initpassword:   'Réinitialiser le mot de passe',
      initpasswordmessage:   'Choisissez votre nouveau mot de passe.',
      connexionusers:   'Connexions utilisateurs',
      connexionuser:   'Connexion utilisateur',
      ipadress: 'Adresse IP',
      login: 'Identifiant',
      password: 'Mot de passe',
      oldpassword: 'Ancien mot de passe',
      plainPassword: 'Nouveau mot de passe',
      confirmPassword: 'Confirmation mot de passe',
      sameAsPassword: 'Le champ de confirmation est différent du mot de passe',
      connexionBtn: 'Connexion',
      updatemypassword: 'Modifier mon mot de passe',
      email: 'Email',
      date: 'Date',
      failed: 'Connexion échouée',
      name: 'Nom',
      surname: 'Nom de famille',
      firstname: 'Prénom',
      lastname: 'Nom de famille',
      enabled: 'Activée',
      blocked: 'Bloqué',
      supervision: 'Supervision',
      create: 'Créer',
      lastlogin: 'Dernière connexion',
      passwordrequestedat: 'Dernière demande de mot de passe oubliée',
      dateblock: 'Dernier blocage du compte',
      myprofile: 'Mon profil',
      createconfirm: 'L\'utilisateura bien été enregistrée.',
      passwordtemp: 'Mot de passe provisoire à transmettre à l\'utilisateur',
      unblockuser: 'Débloquer',
      initpassworduser: 'Réinitialisation du mot de passe de l\'utilisateur',
      initpasswordconfirm: 'La réinitialisation du mot de passe de l\'utilisateur a bien été enregistrée.',
    },
    profil: {
      profil:   'Profil',
      profils:   'Profils',
      profilinterface:   'Profil interface',
      profilinterfaces:   'Profils interface',
      base:   'Défaut',
      blocs:   'Blocs',
    },
    access: {
      access_read:   'Droits - lire',
      connexion_user_read:   'Connexions utilisateurs - lire',
      forgot_password_read:   'Mot de passe oublié - lire',
      profil_read:   'Profil - lire',
      profil_edit:   'Profil - modifier',
      security_parameter_read:   'Paramètres de sécurité - lire',
      security_parameter_edit:   'Paramètres de sécurité - modifier',
      user_read:   'Utilisateur - lire',
      user_edit:   'Utilisateur - modifier',
      user_password_init:   'Réinitialiser mot de passe',
      user_unblock:   'Débloquer utilisateur',
    },
    notification: {
      notification:   'Notification',
      notifications:   'Notifications',
      viewall: 'Marquer tout comme lus',
      view: 'Marquer comme lu',
      noview: 'Marquer comme non lu',
    },
  },
  notification: {
    security: {
      newuser:   'Un nouveau utilisateur a été ajouté : {0}',
      newprofil:   'Un nouveau profil a été ajouté : {0}',
    },
    product: {
      newmachine:   'Une nouvelle machine a été ajouté : {0}',
      newtoolhead:   'Une nouvelle tête outil a été ajouté : {0}',
      newmaterialsupply: 'Un nouveau rack matière a été ajouté : {0}',
      newindustrialcomputer: 'Un nouveau ordinateur industriel a été ajouté : {0}',
      newcontrolunit: 'Une nouvelle unité de contrôle a été ajouté : {0}',
      newaccessory: 'Un nouvel accessoire a été ajouté : {0}',
      newoption: 'Une nouvelle option a été ajoutée : {0}',
      delivery: 'La livraison du produit {0} a été changée pour : {2}',
      changelog: 'Une nouveau changement de version a été ajouté : {0}',
      newsoftwareVersion: 'Un nouveau logiciel a été ajouté : {0}',
      newprintingsurface: 'Un nouvelle surface impression a été ajouté : {0}',
      newoperatingsystem: 'Un nouveau OS a été ajouté : {0}',
    },
    ticket: {
      assignedticket:   'Vous avez un nouveau ticket assigné : {0}',
      newticket:   'Un nouveau ticket a été ajouté : {0}',
      updateticket: 'Le ticket {0} a été mis à jour',
    },
  },
};
